import {AUTH} from "../auth/FirebaseContext";
import axios from "axios";
import {addUserLog} from "../helper/realtimeDatabase";
import {LOG_ACTIONS} from "../constants";

const BSS_URL = process.env.REACT_APP_FIREBASE_BASE_URL + "/bssAPI"

const customAxios = (token, customConfig = {}, customReponseType = {}) => axios.create({
    baseURL: BSS_URL,
    ...customReponseType,
    headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
        ...customConfig
    },
});

export async function emailOnUserCreation(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/emailOnUserCreated`, data);
}

export async function changeContractTypeApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`routeChangeContractType`, data);
}

export async function activateClientApi(uid) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(uid, LOG_ACTIONS.activateUser, {
        uid: uid
    });
    return customAxios(token).post("admin/activateUser", {uid: uid});
}

export async function isEmailValidApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`email/isEmailValid?email=${data}`);
}

export async function getEsirApiKeys(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get("admin/routeGetApiKeys?uid=" + data);
}

export async function deleteEsirApiKey(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.deleteApiKey,data);
    return customAxios(token).post("admin/routeDeleteApiKey", data);
}

export async function addEsirApiKey(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.createApiKey, data);
    return customAxios(token).post("admin/routeCreateNewApiKey", data);
}

export async function advancedSearchApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/admin/routeAdvancedSearch`, data);
}

export async function addNewInvoiceApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.addNewInvoice, data);
    return customAxios(token).post("admin/addNewInvoice", data);
}

export async function sendNoticeApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.sendNotice, data);
    return customAxios(token).post("admin/sendNotice", data);
}

export async function getAllNoticesApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get("admin/getAllNotices", data);
}

export async function getNoticePdfApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token, {}, { responseType: 'arraybuffer' }).get(`admin/getNoticePDF?uid=${data.uid}&timestamp=${data.timestamp}`);
}

export async function fetchTenantsFinancialReportApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/admin/tenantSummary`,data);
}

export async function fetchTenantActivationsApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/admin/tenantActivation`,data);
}

export async function blockPayment(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.blockPayment, data);
    return customAxios(token).post(`/admin/blockPayment`,data);
}

export async function takeAwayPayment(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.removePaymentAllocation, data);
    return customAxios(token).post(`admin/removePaymentAllocation`, data);
}

export async function getUserCardDetailsApi(data){
    const token = await AUTH.currentUser.getIdToken(true);
    if (data.tin!==undefined) {
        if (data.type === "ODS") {
            return customAxios(token, {}, { responseType: 'arraybuffer' }).get(`admin/userTransactions?TIN=${data.tin}&type=${data.type}`)
        }
        return customAxios(token).get(`admin/userTransactions?TIN=${data.tin}`)
    }else if (data.uid!==undefined){
        if (data.type === "ODS") {
            return customAxios(token, {}, { responseType: 'arraybuffer' }).get(`admin/userTransactions?uid=${data.uid}&type=${data.type}`)
        }
        return customAxios(token).get(`admin/userTransactions?uid=${data.uid}`)
    }
    if (data.type === "ODS") {
        return customAxios(token, {}, { responseType: 'arraybuffer' }).get(`admin/userTransactions?type=${data.type}`)
    }
    return customAxios(token).get(`admin/userTransactions?`)
}

export async function uploadXMLPaymentsApi(xmlFile){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.uploadPayments, xmlFile);
    return customAxios(token, { 'Content-Type': 'application/xml' }).post(`admin/uploadPayments`,xmlFile);
}

export async function newUploadXMLPaymentsApi(xmlFile){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.uploadPaymentsNew, xmlFile);
    return customAxios(token, { 'Content-Type': 'application/xml' }).post(`admin/newUploadPayments`, xmlFile);
}

export async function assignPaymentPreprocesedApi(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.assignPaymentPreprocesed, data);
    return customAxios(token).post(`admin/assignPaymentPreprocesed`, data);
}

export async function paymentNotToBeProcessedApi(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.excludePaymentFromProcessing, data);
    return customAxios(token).post(`admin/excludePaymentFromProcessing`, data);
}

export async function blockPaymentPreprocesedApi(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.blockPaymentPreprocessed, data);
    return customAxios(token).post(`admin/blockPaymentPreprocessed`, data);
}

export async function deleteAllFromPreprocessedApi(){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.deleteAllFromPreprocessed, "");
    return customAxios(token).post(`admin/deleteAllFromPreprocessed`);
}

export async function processPaymentsFromPreprocessedApi(){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.processPaymentsFromPreprocessed, "");
    return customAxios(token).post(`admin/processPaymentsFromPreprocessed`);
}

export async function resetPreprocessedPaymentToDefaultApi(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.resetPreprocessedPaymentToDefault, data);
    return customAxios(token).post(`admin/resetPreprocessedPaymentToDefault`, data);
}

export async function generateUserReport(uid, from, to){
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`admin/report/generateUserReports?uid=${uid}&from=${from}&to=${to}`)
}

export async function sendEmail(data){
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`util/sendMail`, data)
}

export async function invoiceCancellation(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.userUID, LOG_ACTIONS.cancelInvoice, data);
    return customAxios(token).post(`admin/cancelInvoice`, data)
}

export async function invoiceDeletion(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.userUID, LOG_ACTIONS.deleteInvoice, data);
    return customAxios(token).post(`admin/deleteInvoice`, data)
}

export async function updateBusinessApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.business, data);
    return customAxios(token).put(`admin/business`, data);
}

export async function insertLocation(location) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/certificate`, location);
}

export async function insertOperator(operator) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/operator`, operator);
}

export async function getClientInfo(tin) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`/getCompanyDetails?TIN=${tin}`);
}

export async function getAllClients(startAfter, limitToFirst) {
    let params = "?";
    if (startAfter && startAfter !== "") {
        params = params + `startAfter=${startAfter}`
    }
    if (limitToFirst && !isNaN(limitToFirst)) {
        params = params + `&limitToFirst=${limitToFirst}`
    }
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`/clients${params}`);
}

export async function insertSeller(seller) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.addUser,seller);
    return customAxios(token).post("/user", seller);
}

export async function deleteClientApi(uid) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(uid, LOG_ACTIONS.deleteUser, {
        uid: uid
    });
    return customAxios(token).delete("/user", {
        data: {
            uid: uid
        }
    });
}

export async function findUsersForPaymentApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post("/findUsers", data);
}
export async function assignPaymentToUserApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.assignPaymentToUser , data);
    return customAxios(token).post("/admin/assignPaymentToUser", data);
}

export async function deleteUserPaymentApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(null, LOG_ACTIONS.resolvePayment, data);
    return customAxios(token).post(`/admin/resolvePayment`, data);
}

export async function requestPasswordReset(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.passwordReset, data);
    return customAxios(token).post(`/user/passwordReset`, data);
}

export async function deleteUserCertificate(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.deleteCertificate, data);
    return customAxios(token).delete(`/certificate`, {
        data: data
    });
}

export async function findClient(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/findUsers`, data);
}

export async function extendLicense(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.temporaryExtendLicense, data);
    return customAxios(token).post(`/admin/temporaryExtendLicense`, data);
}

export async function sendMessageApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).post(`/admin/message`, data);
}

export async function getAllFbUsersApi(startAfter, limitToFirst) {
    let params = "?showAll=true";
    if (startAfter && startAfter !== "") {
        params = params + `&startAfter=${startAfter}`
    }
    if (limitToFirst && !isNaN(limitToFirst)) {
        params = params + `&limitToFirst=${limitToFirst}`
    }
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`/clients${params}`);
}

export async function getLicenseHistory(uid){
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`/license?uid=${uid}&history=false`);
}

export async function changeNumberOfLicenceApi(data){
    const token = await AUTH.currentUser.getIdToken(true);
    await addUserLog(data.uid, LOG_ACTIONS.licenseCount, data);
    return customAxios(token).post(`/license`, data);
}

export async function resetWarehouseAPI(userUid) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).patch("admin/reset-warehouse?uid=" + userUid);
}

export async function generateReportAPI(dateFrom, dateTo, userUid) {
    const token = await AUTH.currentUser.getIdToken(true);
    return customAxios(token).get(`admin/report/generateUserReports?uid=${userUid}&from=${dateFrom}&to=${dateTo}`);
}
